import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';

export default function CompanyGridPropertySubtype({ subtype, onChange }) {
  return (
    <ManagedInput
      checked={subtype.enabled}
      className="ms-4"
      name="enabled"
      type="checkbox"
      onValueChange={enabled => onChange({ ...subtype, enabled })}
    >
      {subtype.label}
    </ManagedInput>
  );
}

CompanyGridPropertySubtype.propTypes = {
  subtype: PropTypes.shape({
    enabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
